module.exports = __webpack_public_path__ + "static/img/32_robot.679a42ed.jpg";